import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

// PrivateRoute component for protecting routes based on authentication and roles
const PrivateRoute = ({ allowedRoles, children }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  // If not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Super admin can access everything
  if (user.role === "superadmin") {
    return children ? children : <Outlet />;
  }

  // If roles are specified and user doesn't have the required role
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // If authenticated and authorized, render the child routes
  return children ? children : <Outlet />;
};

export default PrivateRoute;
